<template>
  <div>
    <NavigationBar
      titel="Abfrageart bearbeiten"
      showBackBtn
      :actions="actions"
    ></NavigationBar>
    <section>
      <v-form
        @submit.prevent="updateItem"
        ref="form"
        v-model="helpers.formIsValid"
      >
        <request-type-editor
          v-model="requestType"
          mode="edit"
        ></request-type-editor>
      </v-form>
    </section>
  </div>
</template>

<script>
import { db } from "@/firebase";
import { AVAILABILITY } from "@/store/modules.js";
import { UPDATE_REQUEST_TYPE } from "@/store/action-types.js";
import NavigationBar from "@/components/_systemwide/NavigationBar.vue";
import RequestTypeEditor from "@/components/availability/requests/RequestTypeEditor.vue";

export default {
  name: "scheduling-config-tab-request-type-edit",
  components: {
    NavigationBar,
    RequestTypeEditor,
  },
  data() {
    return {
      actions: [
        {
          title: "Speichern",
          icon: "mdi-content-save",
          actionStyle: "textBtnSubmit",
          function: this.updateItem,
        },
      ],
      requestType: null,

      helpers: {
        formIsValid: false,
      },
    };
  },
  computed: {},
  created() {
    this.initialize();
  },
  watch: {
    $route: "initialize",
  },
  methods: {
    initialize() {
      db.collection("organizations")
        .doc(this.$route.params.organizationId)
        .collection("requestTypes")
        .doc(this.$route.params.itemId)
        .get()
        .then((doc) => {
          if (doc.exists) {
            this.requestType = doc.data();
          } else {
            // doc.data() will be undefined in this case
            console.log("No such document!");
          }
        })
        .catch(function (error) {
          console.log("Error getting document:", error);
          return false;
        });
    },
    validate() {
      this.$refs.form.validate();
    },
    updateItem() {
      this.validate();

      if (this.helpers.formIsValid) {
        var res = confirm(
          "Bist Du sicher, dass Du die Veranstaltungsart aktualisieren möchtest und alle bevorstehenden Veranstaltungen angepasst werden sollen?"
        );
        if (res == true) {
          this.$store.dispatch(`${AVAILABILITY}${UPDATE_REQUEST_TYPE}`, {
            organizationId: this.$route.params.organizationId,
            itemId: this.$route.params.itemId,

            title: this.requestType.title,
            shortTitle: this.requestType.shortTitle,
            description: this.requestType.description,
            color: this.requestType.color,
            sortKey: this.requestType.sortKey,
          });
        }
      } else {
        alert("Prüfe Deine Eingabe und versuche es erneut.");
      }
    },
  },
};
</script>
